import { useContext } from "react";
import { ProductContext } from "./ProductCard";

import styles from '../styles/styles.module.css'

export interface Props {
    className?: string;
    style?: React.CSSProperties
    consulta?: boolean;
}

export const ProductButtons = ({ className, style, consulta }: Props) => {

    const { increaseBy, counter } = useContext(ProductContext);

    return (
        <div
            className={`${styles.buttonsContainer} ${className}`}
            style={style}
        >
            <button
                className={styles.buttonMinus}
                onClick={() => increaseBy(-1)}
                type='button'> - </button>

            <div className={styles.countLabel}> {counter} </div>

            <button
                className={styles.buttonAdd}
                onClick={() => increaseBy(+1)}
                type='button'> + </button>
        </div>
    );
}